var map = {
	"./social-500px.svg": 87,
	"./social-dribbble.svg": 88,
	"./social-facebook.svg": 89,
	"./social-github.svg": 90,
	"./social-google.svg": 91,
	"./social-instagram.svg": 92,
	"./social-odnoklassniki.svg": 93,
	"./social-rediit.svg": 94,
	"./social-stackoverflow.svg": 95,
	"./social-steam.svg": 96,
	"./social-twitch.svg": 97,
	"./social-twitter.svg": 98,
	"./social-vkontakte.svg": 99,
	"./social-windows.svg": 100,
	"./social-yahoo.svg": 101
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars ^\.\/social\-.*\.svg$
// module id = 86
// module chunks = 0